import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { analytics } from "../../../analytics";
import { SiteConstants } from "../../../constants/constant";
import { appleSignInAuth } from "../../../util/commonFunctions";
const SignupInit = (props) => {
  useEffect(() => {
    appleSignInAuth();
  });

  const fireSigupStarted = (signup, nextPage) => {
    analytics("registration_" + signup + "_started");
    try {
      const search = props.location.search;
      const params = new URLSearchParams(search);
      var campaignValue = params.get(SiteConstants.Campaign);
      // analytics(`registration_${signup}_started_${campaignValue}`);
    } catch (error) {}
    if (nextPage) {
      props.lazyLoadComponent(props.nextPage);
    }
  };

  return (
    <div className="signUpInit text-center">
      <h3>Sign up, it’s free</h3>
      <p className="subHeading">
        Stop playing catch-up. Start watching ausbiz.
      </p>
      {props.message && <p className="error">{props.message}</p>}
      <div className="signup_new_container">
        <div className="leftContainer">
          <div>
            <p>Daily stock tips and news from experts</p>
            <p>Free live and on-demand streaming access </p>
            <p>Exclusive interviews with Australia’s top money managers</p>
            <p>Australia’s leading stock market newsletter</p>
          </div>
          <div className="signUpImg">
            <img src="../../assets/ausbiz_new_signup_page.jpg" alt="logo"></img>
          </div>
        </div>
        <div className="divLine"></div>
        <div className="rightContainer">
          <a
            className="googleBtn btn"
            onClick={() => fireSigupStarted("google")}
            href="/google"
          >
            <div className="signup_icon">
              <img src="/assets/svg/logoGoogle_new.svg" alt="linkedin" />
            </div>
            <span>Continue with Google</span>
          </a>

          <a
            href="/linkedin"
            className="linkedinBtn btn"
            onClick={() => fireSigupStarted("linkedin")}
          >
            <div className="signup_icon">
              <img
                src="/assets/svg/iconAppLinkedinBlue_new.svg"
                alt="linkedin"
              />
            </div>
            <span>Continue with Linkedin</span>
          </a>
          <div className="shadow-apple-button" tabIndex={"0"}>
            <div className="signup_icon">
              <img src="../../../assets/svg/apple_new.svg" />
            </div>
            <span className="apple-text">Continue with Apple</span>
          </div>
          <div
            className={"apple-sign-in"}
            id="appleid-signin"
            data-color="white"
            data-border="true"
            data-type="continue"
            onClick={() => fireSigupStarted("apple")}
          />
          <div className="singup_or">OR</div>
          <button
            type="button"
            className="emailSignupBtn btn btn-outline-secondary"
            onClick={() => fireSigupStarted("email", true)}
          >
            <div className="signup_icon">
              <img src="../../../assets/svg/email_new.svg" />
            </div>
            <span>Sign up with email</span>
          </button>
          <p className="text-center singInLink_new">
            Already have an account?
            <a
              href="javascript:void(null);"
              onClick={() => props.changeFormHandler("signin")}
            >
              &nbsp;&nbsp;Sign in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default withRouter(SignupInit);
